import { Nav } from '@dagens/carrot';
import { useTranslation } from '@dagens/frontend-i18n';

import { useAppSelector } from '../../../../_common/hooks/reduxHooks';
import { MenuLogout, MenuSecondaryItems } from './shared';

export const MenuConsumer = () => {
  const { t } = useTranslation();
  const { name, email } = useAppSelector(({ auth }) => {
    return {
      name: auth.name,
      email: auth.loginEmail,
      webshop: auth.shopUrl
    };
  });

  return (
    <Nav.Menu heading={t('common:Menu')}>
      <Nav.MenuGroup title={t('common:Account', { name })}>
        <Nav.MenuPrimaryItem text={t('consumer:MyProfile')} to="/profile" />
        <Nav.MenuPrimaryItem
          text={t('common:BillingAccountHeader')}
          to="/billing-account"
        />
      </Nav.MenuGroup>
      <Nav.MenuDivider />
      <Nav.MenuGroup title={t('common:You', { email })}>
        <Nav.MenuPrimaryItem
          text={t('common:header.switchRole')}
          to="/switch-role"
        />
      </Nav.MenuGroup>
      <Nav.MenuDivider />
      <MenuSecondaryItems />
      <Nav.MenuDivider />
      <MenuLogout />
    </Nav.Menu>
  );
};
